import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'


export default function Navbar(props) {
    return (
        <>
            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode} `}>
                <div className="container-fluid">
                    <Link className={`navbar-brand text-${props.mode === 'dark' ? 'light' : 'dark'} `} to="/">{props.title}</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className={`nav-link active text-${props.mode === 'dark' ? 'light' : 'dark'} `} aria-current="page" to="/">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`nav-link text-${props.mode === 'dark' ? 'light' : 'dark'} `} to="/about">About</Link>
                            </li>
                        </ul>
                        {/* <form className="d-flex" role="search">
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-primary btn-outline" type="submit">Search</button>
                        </form> */}
                        <div className={`form-check form-switch text-${props.mode === 'dark' ? 'light' : 'dark'}`} >
                            <input className="form-check-input" onClick={props.toggleMode} type="checkbox" id="flexSwitchCheckDefault" />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{props.modeText}</label>
                        </div>
                    </div>
                </div>
            </nav>

        </>
    )
}

Navbar.defaultProps = {
    title: 'TextHelper'
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired
}